import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { Option, Pagination } from '@/common/types';
import { API_URL } from '@/dtos';

interface BalanceTierPayload {
  id: number;
  apy_high: number;
  apy_low: number;
  balance_from: number;
  balance_to: number;
  interest_rate: number;
  version_id: number;
}
interface InterestRateVersionPayload {
  id: number;
  natural_id: string;
  balance_tier: BalanceTierPayload[];
}
interface InterestRatePayload {
  id: number;
  name: string;
  versions: InterestRateVersionPayload[];
}
export default () => {
  const { isLoading, data, isSuccess } = useQuery([API_URL.INTEREST_RATE_TEMPLATES_ACTIVE], () =>
    // TODO: this DTO type is missing
    api.get<Pagination<InterestRatePayload>>(API_URL.INTEREST_RATE_TEMPLATES_ACTIVE)
  );

  const formatedOptions = useMemo(() => {
    const list = data?.data?.content;

    return list?.map(
      (item) =>
        ({
          key: _.toString(item?.id),
          value: item?.name,
          title: item?.name,
        }) as Option
    );
  }, [data]);

  return {
    isSuccess,
    formatedOptions,
    isLoading,
  };
};
